<template>
  <b-navbar
    v-if="headerData !== null"
    id="navbar"
    class="navbar navbar-expand-sm border-bottom box-shadow"
    v-bind:style="{ top: styletop }"
  >
    <div id="headerlogosmall" v-if="!headerData.hideLogo" class="d-xl-none">
      <a href="/" class="navbar-brand"></a>
    </div>

    <div class="headerContainer">
      <div
        class="EnvironmentNotice d-none d-xl-table-cell"
        v-if="headerData.ShowEnvironmentWarnining"
      >
        <h3 class="mb-0">
          <b>{{ headerData.EnvironmentHeader }}</b>
        </h3>
      </div>
      <b-navbar-brand href="/" class="d-none d-xl-table-cell">
        <img class="logo-img"
          v-if="!headerData.hideLogo"
          src="https://yoyosharedstorage.blob.core.windows.net/static-website/LL_Logo_New.jpg"
          width="250px"
        />
      </b-navbar-brand>
    </div>

    <b-navbar-nav>
      <main-menu-item
        v-for="item in headerData.MainMenu"
        v-bind:use-internal-routes="useInternalRoutes"
        v-bind:menuitem="item"
        v-bind:key="item.Link"
      ></main-menu-item>
    </b-navbar-nav>

    <b-navbar-nav class="ml-auto">
      <b-nav-form
        v-if="headerData.Search != null"
        class="form-inline"
        :action="headerData.Search.SearchUrl"
        :method="headerData.Search.SearchMethod"
      >
        <b-input-group>
          <b-form-input placeholder="Search" class="mr-sm-0" name="SearchText"></b-form-input>
          <b-input-group-append>
            <b-button variant="success" type="submit">
              <i class="fa fa-search pull-left button-icon" aria-hidden="true"></i>
              <span class="d-sm-none d-xl-inline">Search</span>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-nav-form>

      <b-nav-item-dropdown
        v-if="
          headerData.AppSwitcherMenu != null &&
            headerData.AppSwitcherMenu.length > 0
        "
        class="appswitcherdrop"
        text="app"
        toggle-class="appswitcher-drop-down"
        name="appSwitcherDropDown"
      >
        <template v-slot:button-content>
          <i
            id="appswitchericon"
            class="fa fa-th fa-2x pull-left button-icon"
            aria-hidden="true"
          ></i>
        </template>
        <template v-slot:default>
          <div class="shadow-lg p-4 bg-white rounded" id="appswitchermenu">
            <div
              v-for="item in headerData.AppSwitcherMenu"
              v-bind:key="item.Link"
              class="border rounded m-1 p-1 border-light"
            >
              <a :href="item.Link">
                <i aria-hidden="true" v-bind:class="appIconClasses(item)"></i>
                {{ item.Name }}
              </a>
            </div>
          </div>
        </template>
      </b-nav-item-dropdown>

      <div v-bind:title="environmentToolTip">
        <div style="line-height: 20px; text-align: left;">
          <b-nav-item-dropdown
            v-if="headerData.SegmentationDetails != undefined"
            class="segmentationdrop"
            text="app"
            name="segmentationDropDown"
          >
            <template v-slot:button-content>
              {{ headerData.SegmentationDetails.SegmentationHeader }}
              <img
                style="margin-left: 10px;"
                :src="headerData.SegmentationDetails.SegmentationFlagUrl"
              />
            </template>
            <template v-slot:default>
              <div
                class="shadow-lg p-4 bg-white rounded"
                id="segmentationswitchermenu"
              >
                <div class="list-group">
                  <a
                    v-on:click="
                      $emit('segmentationselected', item.segmentationSystemKey)
                    "
                    href="#"
                    v-bind:class="item.cssClasses"
                    v-for="item in segmentations"
                    v-bind:key="item.segmentationSystemKey"
                    :name="'segmentation_' + item.segmentationSystemKey"
                  >
                    <div class="d-flex w-100 justify-content-between">
                      <h5 class="mb-1">
                        <img
                          style="margin-right: 5px; height: 15px;"
                          :src="item.flagUrl"
                        />
                        {{ item.name }}
                      </h5>
                    </div>
                    <p class="mb-1">{{ item.description }}</p>
                  </a>
                </div>

                <div id="languagePicker">
                  <h6
                    class="pt-2"
                  >{{ headerData.SegmentationDetails.SelectedLanguageTitle }}</h6>
                  <div
                    class="btn-group"
                    role="group"
                    aria-label="Basic example"
                  >
                    <button
                      v-bind:class="item.cssClasses"
                      v-for="item in languages"
                      v-bind:key="item.languageKey"
                      type="button"
                      v-on:click="$emit('languageselected', item.languageKey)"
                      :name="'language_' + item.languageKey"
                    >{{ item.name }}</button>
                  </div>
                </div>
              </div>
            </template>
          </b-nav-item-dropdown>

          <small
            v-if="headerData.SegmentationDetails == undefined"
            id="environmentheader"
          >{{ headerData.EnvironmentHeader }}</small>
        </div>
        <div>
          <b-nav-item-dropdown
            toggle-class="user-drop-down"
            right
            name="userDropDown"
            id="userDropDown"
          >
            <template v-slot:button-content>
              <span class="d-sm-none d-xl-inline">
                {{
                headerData.User.Name
                }}
              </span>
              <span class="d-xl-none d-sm-inline">
                {{
                headerData.User.ShortName
                }}
              </span>
            </template>
            <user-menu-item
              v-for="item in headerData.UserMenu"
              v-bind:menuitem="item"
              v-bind:use-internal-routes="useInternalRoutes"
              v-bind:key="item.Link"
            ></user-menu-item>
          </b-nav-item-dropdown>
        </div>
      </div>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
  import MainMenuItem from "./MainMenuItem";
  import UserMenuItem from "./UserMenuItem";
  import {
    BNavbar,
    BNavbarBrand,
    BNavbarNav,
    BNavForm,
    BFormInput,
    BNavItemDropdown,
    BButton,
    BInputGroup,
    BInputGroupAppend,
  } from "bootstrap-vue";
  import "bootstrap/dist/css/bootstrap.css";
  import "bootstrap-vue/dist/bootstrap-vue.css";

  export default {
    data: function () {
      return {
        prevScrollpos: 0,
        styletop: "-85px;",
      };
    },
    methods: {
      appIconClasses: function (appItem) {
        return "fa fa-" + appItem.IconName + " fa-4x";
      },

      segmentationItemClasses: function (segItem) {
        var postFix = "availablesegmentation";
        if (
          segItem.bookingSystemKey ===
          this.headerData.SegmentationDetails.selectedBookingSystemKey
        )
          postFix = "selectedsegmentation";

        return "list-group-item " + postFix;
      },
    },
    computed: {
      environmentToolTip() {
        if (this.headerData.SelectedSegmentation != null) {
          return this.headerData.EnvironmentHeader;
        }

        return this.headerData.EnvironmentHeader;
      },
      segmentations() {
        var result = [];

        this.headerData.SegmentationDetails.AvailableSegmentations.forEach(
          (element) => {
            var item = {
              name: element.Name,
              flagUrl: element.FlagUrl,
              description: element.DescriptionNotSelected,
              segmentationSystemKey: element.SegmentationSystemKey,
              cssClasses: "list-group-item availablesegmentation",
            };

            if (
              element.SegmentationSystemKey ===
              this.headerData.SegmentationDetails.SelectedSegmentationKey
            ) {
              item.cssClasses = "list-group-item selectedsegmentation";
              item.description = element.DescriptionSelected;
            }

            result.push(item);
          }
        );

        return result;
      },
      languages() {
        var result = [];
        this.headerData.SegmentationDetails.AvailableLanguages.forEach(
          (element) => {
            var item = {
              name: element.LocalName,
              languageKey: element.LanguageKey,
              cssClasses: "btn btn-secondary",
            };

            if (
              element.LanguageKey ==
              this.headerData.SegmentationDetails.SelectedLanguageKey
            ) {
              item.cssClasses = "btn btn-secondary active";
            }
            result.push(item);
          }
        );

        return result;
      },
    },

    components: {
      MainMenuItem,
      UserMenuItem,
      BNavbar,
      BNavbarBrand,
      BNavbarNav,
      BNavForm,
      BFormInput,
      BNavItemDropdown,
      BButton,
      BInputGroup,
      BInputGroupAppend,
    },
    props: {
      headerData: Object,
      useInternalRoutes: Boolean,
    },
  };
</script>

<style>
  .appswitcher-drop-down:after {
    content: none !important;
  }

  .appswitcher-drop-down {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }

  .user-drop-down {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    font-size: 1rem;
  }

  a {
    color: #3D4763;
  }

  .box-shadow {
    box-shadow: 0 1px 5px #888;
  }

  body {
    padding-top: 75px !important;
  }

  .navbar {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
    position: fixed !important; /* Make it stick/fixed */
    top: 0; /* Stay on top */
    right: 0;
    width: 100%; /* Full width */
    transition: top 1s; /* Transition effect when sliding down (and up) */
    background-color: #fff;
    z-index: 999;
  }

  .navbar,
  .navbar a {
    color: #3D4763 !important;
  }

  .nav-link {
    color: #3D4763 !important;
  }

  .menu-item-link {
    color: #3D4763 !important;
  }

  .dropdown-menu {
    background-color: #fff;
    z-index: 999;
  }
  
  .logo-img {
    height: 50px;
    width: auto;
  }

  #headerlogosmall {
    background: url("https://yoyosharedstorage.blob.core.windows.net/static-website/LL_Logo_New.jpg")
    0 0;
    height: 50px;
    width: auto;
  }

  #headerlogosmall a {
    width: 190px;
    height: 50px;
  }

  .appswitcherdrop ul {
    min-width: 0px !important;
    border: 0px solid black;
  }

  .appswitcherdrop {
    padding-top: 0px;
    margin-left: 3px;
  }

  .segmentationdrop {
    padding-top: 0px;
  }

  .segmentationdrop ul {
    min-width: 0px !important;
    border: 0px solid black;
  }

  .segmentationdrop a {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
  }

  #appswitchericon {
    margin-right: 0px;
    margin-top: 2px;
    font-size: 46px;
  }

  #appswitchermenu {
    width: 500px;

    position: fixed;
    top: 70px;
    right: 5px;
  }

  #appswitchermenu div {
    width: 140px;
    height: 120px;
    float: left;
    text-align: center;
    color: #575757;
  }
  #appswitchermenu div a {
    color: #575757 !important;
  }

  #appswitchermenu div a i {
    display: block;
  }

  #segmentationswitchermenu {
    width: 500px;

    position: fixed;
    top: 70px;
    right: 5px;
  }

  #environmentheader {
    padding-left: 8px;
    font-size: 1rem;
    text-align: left;
  }

  #userdropdown {
    padding-top: 0px;
    font-size: 1rem;
  }

  .button-icon {
    margin-top: 4px;
  }

  .availablesegmentation {
    padding-left: 10px !important;
    padding-top: 5px !important;
    padding-bottom: 5px !important;
    color: #3D4763 !important;
    height: 85px;
  }

  .selectedsegmentation {
    padding-left: 10px !important;
    padding-top: 5px !important;
    padding-bottom: 5px !important;
    background-color: #60799f !important;
    color: white;
    height: 85px;
  }

  .selectedsegmentation div h5 {
    color: white;
  }

  .selectedsegmentation p {
    color: white;
  }

  #languagePicker {
    color: #3D4763 !important;
  }

  #languagePicker div button {
    background-color: #60799f;
  }

  #languagePicker .active {
    background-color: #3D4763;
  }

  .EnvironmentNotice {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    color: red;
    min-width: 200px;
    line-height: 50%;
  }

  .headerContainer {
    position: relative;
    text-align: center;
  }

  .navbar {
    background-color: #3D4763;
  }
  .navbar-light .navbar-nav .nav-link {
    color: #eeeeee !important;
  }
</style>
